var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.presenter.textClass,attrs:{"href":_vm.shipment.tracking_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.presenter.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }